<template>
  <el-dialog title="绑定关联关系" :visible.sync="dialogVisible" width="700px" @closed="handleClose">
    <el-table :data="skuList" style="width: 100%">
      <el-table-column label="" width="60px">
        <template slot-scope="{ row }">
          <el-radio v-model="checked_skuid" :label="row._skuid">
            <span style="visibility: hidden"> </span>
          </el-radio>
        </template>
      </el-table-column>
      <el-table-column property="imageUrl" label="预览图" width="120">
        <template slot-scope="{ row }">
          <div style="margin: 14px 0px 5px">
            <ImgUpload :width="46" :height="46" :size="100" :onlyPreview="true" :file="getSkuImageUrl(row)" :isSingle="true" />
          </div>
        </template>
      </el-table-column>
      <el-table-column property="skuOuterId" label="商家编码" width="120"> </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>
  
  <script>
import ImgUpload from '@/components/Uploads/ImgUpload';

import { prodDetailByBaseItemIds } from '@/servers/prod/center';
import { cloneDeep } from 'lodash';
export default {
  name: 'ProductMappingDialog',
  components: {
    ImgUpload,
  },
  props: {
    baseItemId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      skuList: [],
      checked_skuid: '',
      opts: {}
    };
  },
  methods: {
    handleShow(opts) {
      this.opts = opts
      this.dialogVisible = true;
      this.getBaseDetail();
    },
    getSkuImageUrl(row) {
      let imageUrl = row['skuSpecifications'][0]?.imageUrl || '';
      return imageUrl === '/resources/css/build/images/no_pic.png' ? '' : imageUrl;
    },
    async getBaseDetail() {
      if (!this.baseItemId) {
        return false;
      }
      const res = await prodDetailByBaseItemIds({
        baseItemIds: [this.baseItemId],
      });
      const { skuList = [] } = res[0];
      this.skuList = skuList.map((item, index) => {
        const _skuid = item['skuSpecifications'].map(sp => sp.valueKey).join('-') + '_' + index;
        return {
          ...item,
          _skuid,
        };
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.checked_skuid = '';
      this.opts.onCancel && this.opts.onCancel()
    },
    handleSubmit() {
      if (!this.checked_skuid) {
        this.$message.warning('请选择需要绑定的编码');
        return false;
      }
      const selectRow = this.skuList.find(item => item._skuid === this.checked_skuid);
      this.opts.onSuccess && this.opts.onSuccess(cloneDeep(selectRow))
      this.handleClose();
    },
  },
};
</script>
  
  <style></style>
  